 $(function () {
  let case_popup_left_container_container;
  let caseGallerySwipersInitialized = false;

  function initializeCaseGalleries() {
    if (caseGallerySwipersInitialized) return;

    $(".case-popup-left .left-swiper").each(function () {
      const gallery = this;
      const target = gallery.querySelector("[data-case-gallery-target]");
      const template = gallery.querySelector(".case-gallery-template");

      if (target && template && !target.children.length) {
        target.appendChild(template.content.cloneNode(true));
      }

      new Swiper(gallery, {
        pagination: {
          el: gallery.querySelector(".swiper-pagination"),
          clickable: true,
        },
      });
    });

    caseGallerySwipersInitialized = true;
    if (case_popup_left_container_container) {
      case_popup_left_container_container.updateAutoHeight(0);
    }
  }

  function changeProductQty(that,flag=false){
      let val = !flag ? +that.data("qty") : 0,
       cur_val = +that.parents(".case-item-container").find(".js-case-qty__num").prop("value") + val;
        let max=+that.parents(".case-item-container").find(".js-case-qty__num").prop("max")
    if(cur_val>=0 && cur_val<=max)  {
      that.parents(".case-item-container").find(".js-case-qty__num").prop("value", cur_val);
      that.parents(".case-container-item").find(".tips-content").length>0 && that.parents(".case-container-item").find(".tips-content").hide()
    }else if(cur_val>max){
      that.parents(".case-item-container").find(".js-case-qty__num").prop("value", max);
      that.parents(".case-container-item").find(".tips-content").length>0 && that.parents(".case-container-item").find(".tips-content").show()
    }
  }
  function calcProductPrice(total_price){
   return  window.theme.Currency.formatMoney(total_price, window.theme.strings.moneyFormat)
  }
  function update_out_inside_qty(direction = "outside") {
    let str = direction == "inside" ? ".case-popup-content" : ".header-case-content";
    let str_1 = direction == "inside" ? ".header-case-content" : ".case-popup-content";
     $(`${str} .case-item-container`).each(function () {
      let id = +$(this).find(".js-case-qty__num").data("id"),
        val = $(this).find(".js-case-qty__num").prop("value"),
        index=$(this).data("index")
      $(`${str_1} .case-item`).find(`input[data-id=${id}]`).prop("value", val);
      updateProductPrice( $(`${str_1} .case-container-item[data-index="${index}"]`));
    });
  }
  


  function updateProductPrice(that) {
    let this_val=that.find(".js-case-qty__num")
        val= +this_val.prop("value")>0 ? this_val.prop("value") : 1
       total_price=val * this_val.data("price") 
        flag=that.hasClass("tips-container")
     let compare_at_price = val * this_val.data("compare_at_price")
      that.find(".item-price .on_sale-price").html( calcProductPrice(total_price) );
      compare_at_price>0 && that.find(".item-price .compare_at-price").html( calcProductPrice(compare_at_price) );
    if(flag){
      that.find(".item-price").html(calcProductPrice(total_price) )
    }
  }

  function fadeInPopUp() {
    initializeCaseGalleries();
    $(".product-showcase-info-container .case-popup-content").removeClass("caseopacity0");
    $(".product-showcase-info-container").find(".tips-content").hide()
    update_out_inside_qty();
  }
  function fadeOutPopUp(flag = false) {
    $(".product-showcase-info-container .case-popup-content").addClass("caseopacity0");
    if (flag) {
      update_out_inside_qty("inside");
    }
  }
  function setOriginPopUpContent(index) {
    $(".case-popup-right")
      .find(`.right-item[data-index="${index}"]`)
      .addClass("active")
      .siblings()
      .removeClass("active");
    case_popup_left_container_container.slideTo(index);
  }

 $(".case-popup-content").click(function(){
  fadeOutPopUp();
 })
$(".case-popup-content-container").click(function(event){
  event.stopPropagation()
})
  $(".product-showcase-info-container .header-case-btn").on(
    "click",
    function () {
      // 点击弹出窗口
      fadeInPopUp();
    }
  );
  $(".product-showcase-info-container .case-hide-btn").on("click", function () {
    // 点击隐藏窗口
    fadeOutPopUp();
  });
  // 点击对应的item进入弹窗
  $(".product-showcase-info-container .header-case-content .case-item").on(
    "click",
    function () {
      let index = $(this).parents(".swiper-slide").data("index");
      setOriginPopUpContent(index);
      fadeInPopUp();
      let val=+$(this).find(".js-case-qty__num").prop("value")
      if(val>0){
        $(`.case-popup-right .right-item[data-index="${index}"]  .add_to_cart_btn`).addClass("active")
      }else{
        $(`.case-popup-right .right-item[data-index="${index}"]  .add_to_cart_btn`).removeClass("active")
      }
      
    }
  );
  
  // 点击该处按钮实现+1   点击该处按钮实现-1
  $(".product-showcase-info-container .js-case__adjust").on(
    "click",
    function (event) {
      let that = $(this),that_parent=$(this).parents(".case-item-container");
      changeProductQty(that)
      updateProductPrice(that_parent);
      if(!!$(this).data("layout")){
        triggerAccessoryPriceEvent(); 
      }
      return false;
    }
  );
  $(".product-showcase-info-container .case-popup-content .js-case-qty__num").on("change",function(){
        let that=$(this),that_parent=$(this).parents(".case-item-container");
        updateProductPrice(that_parent);
        changeProductQty(that,true)
  })
  // 弹窗切换item状态
  $(".case-popup-right .right-item").on("click", function () {
    let index = $(this).data("index");
    setOriginPopUpContent(index);
  });
  // m端点击弹窗关闭
  $(".case-popup-left .m-close ").on("click", function () {
      fadeOutPopUp();
  });
  //点击确定加购
  $(".case-popup-left .confirm-btn ").on("click", function () {
    let index=$(this).parents(".left-item").data("index")
    let val=+$(this).parents(".case-item-container").find(".js-case-qty__num").prop("value")
      update_out_inside_qty("inside");
      calcProductPrice()
      triggerAccessoryPriceEvent(); 
      if(val>0){
        $(`.case-popup-right .right-item[data-index="${index}"]  .add_to_cart_btn`).addClass("active")
       }else{
        $(`.case-popup-right .right-item[data-index="${index}"]  .add_to_cart_btn`).removeClass("active")
       }
  });

  //循环里面的swiper
  let swiper_obj= document.querySelector(".case-popup-left-container>.swiper")
  if(swiper_obj){
   case_popup_left_container_container = new Swiper( swiper_obj,{
      allowTouchMove: false,
      autoHeight:true,
      effect: "fade",
      fadeEffect: { crossFade: true },
      
    }

  );
  }
  

  function swiperFn(){
    if ($(window).width() <= 589) {
    let obj=document.querySelector(".header-case-content .swiper")
    if(obj){
      new Swiper(obj, {
       autoHeight:true,
       navigation: {
         nextEl: ".header-case-content .swiper-button-next",
         prevEl: ".header-case-content .swiper-button-prev",
       },
    });
    }
  }
  }
  swiperFn()
  $(window).resize(function(){
    swiperFn()
  })

  function triggerAccessoryPriceEvent() {
    const { accessoryTotal, accessoryCompareTotal } = calculateAccessoryTotal();
    document.dispatchEvent(new CustomEvent("accessory:priceChange", {
      bubbles: true,
      detail: {
        accessoryPrice: accessoryTotal, // 配件总售价
        accessoryComparePrice: accessoryCompareTotal // 配件总原价
      }
    }));
  }
  function calculateAccessoryTotal() {
    let accessoryTotal = 0; // 配件总售价
    let accessoryCompareTotal = 0; // 配件总原价

    // 遍历所有配件数量输入框，累加价格
    $(".header-case-content .case-item .js-case-qty__num").each(function () {
      const qty = +$(this).prop("value") || 0;
      if (qty <= 0) return; 

      const unitPrice = +$(this).data("price") || 0;
      const unitComparePrice = +$(this).data("compare_at_price") || unitPrice;

      accessoryTotal += unitPrice * qty;
      accessoryCompareTotal += unitComparePrice * qty;
    });

    return { accessoryTotal, accessoryCompareTotal };
  }

});
